var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPresentationChart01 = function SvgPresentationChart01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.827 20.212a.88.88 0 0 1-.645-.26.88.88 0 0 1-.259-.644V18.5H3.308q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V6.308q0-.758.525-1.283T3.308 4.5h17.384q.758 0 1.283.525t.525 1.283v10.384q0 .758-.525 1.283t-1.283.525h-1.615v.808a.88.88 0 0 1-.259.645.88.88 0 0 1-.645.259zM3.307 17h17.385a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V6.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H3.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v10.384q0 .116.096.212a.3.3 0 0 0 .212.096"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.875 16v-2.7H7.45V16zm3.572 0v-5.7H11V16zm3.597 0v-4.7h1.531V16zm3.597 0V7.3h1.51V16z"
  })));
};
export default SvgPresentationChart01;